// extracted by mini-css-extract-plugin
export var container = "_5q-0";
export var error = "_5q-9";
export var label = "_5q-5";
export var light = "_5q-6";
export var md = "_5q-3";
export var sm = "_5q-2";
export var thin = "_5q-8";
export var thinBold = "_5q-7";
export var vertical = "_5q-4";
export var xs = "_5q-1";